export default "__VITE_ASSET__85d0d006__"